import _classCallCheck from "/u01/apps/contentful/dw-uk-vineyard-partners/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/u01/apps/contentful/dw-uk-vineyard-partners/node_modules/@babel/runtime/helpers/esm/createClass.js";
require('isomorphic-fetch');
require('es6-promise').polyfill();
var VERSIONS = [1];
var routes = {};
VERSIONS.forEach(function (version) {
  routes[version] = require("./version/".concat(version, "/global.json"));
});
var Skynet = /*#__PURE__*/function () {
  function Skynet() {
    var apiBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '//www.laithwaites.co.uk';
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var country = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, Skynet);
    this.routes = routes[version];
    this.apiBase = apiBase;
    this._setupRoutes();
  }
  _createClass(Skynet, [{
    key: "_setupRoutes",
    value: function _setupRoutes() {
      var _this = this;
      Object.keys(this.routes).forEach(function (key) {
        _this._setupRoute(_this, _this.routes, key);
      });
    }
  }, {
    key: "_setupRoute",
    value: function _setupRoute(target, definition, key) {
      var _this2 = this;
      if (definition[key].uri !== undefined) {
        target[key] = this._dispatch.bind(this, definition[key]);
      } else {
        target[key] = {};
        Object.keys(definition[key]).forEach(function (subkey) {
          _this2._setupRoute(target[key], definition[key], subkey);
        });
      }
    }
  }, {
    key: "_dispatch",
    value: function _dispatch() {
      var arg = arguments,
        route = arg[0],
        params,
        callback,
        uri;
      if (typeof arg[1] === 'function') {
        callback = arg[1];
      } else {
        params = arg[1];
        callback = arg[2];
      }

      // parse the URL for special params
      uri = route.uri.replace(/\{\{(.*?)\}\}/g, function (x) {
        var replaced = '';
        if (x) {
          x = x.replace('{{', '').replace('}}', '');
          // look in the params object
          route.params.forEach(function (param) {
            if (param.name === x && params[param.name]) {
              replaced = params[param.name];
              // remove all the params in the URL from the params 
              // object so they arent sent twice
              if (!param.body) {
                delete params[param.name];
              }
            }
          });
        }
        return replaced;
      });
      return this._request(route.method.toUpperCase(), this.apiBase + uri, params);
    }
  }, {
    key: "_serialize",
    value: function _serialize(obj) {
      var str = [];
      for (var p in obj) {
        if (obj.hasOwnProperty(p)) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
      }
      return str.join('&');
    }
  }, {
    key: "_request",
    value: function _request(method, uri, params) {
      var options = {
        method: method,
        credentials: 'same-origin'
      };

      // if we have something in our params object
      if (JSON.stringify(params) !== JSON.stringify({})) {
        if (method.toUpperCase() === 'GET') {
          var serializedParams = this._serialize(params);
          if (serializedParams) {
            uri += '?' + this._serialize(params);
          }
        } else if (typeof params === 'object') {
          // JSON
          options.headers = {
            'Content-Type': 'application/json'
          };
          options.body = JSON.stringify(params);
        }
      }
      return fetch(uri, options);
    }
  }]);
  return Skynet;
}();
export default Skynet;